import React, { useState, useEffect } from "react";

import UserService from "../Services/user.service";
import AuthService from "../Services/auth.service";

import UploadFile from "../components/UploaderFile/UploaderFile.component";
import TbAllTrainSess from '../components/TbAllTrainSess/table';
import '../App.css';
import Insertweek from "../components/insertweek/insertweek";

const BoardAdmin = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    UserService.getAdminBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  const user=AuthService.getCurrentUser();
  const caseone=user.firstname.toString().substring(0,1).toUpperCase();
  const caseresto=user.firstname.toString().substring(1,user.firstname.toString().lenght);

  const [allusers, setAllusers]= useState("");

  useEffect(() => {
    UserService.getAllUsers().then(
      (response) => {
        setAllusers(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setAllusers(_content);
      }
    );
  }, []);

  //console.log(allusers.lenght);
  var names=[];
  var codenames=[];
  var userload=[];
  var userobj=[];

  for(var i=0;i<allusers.length;i++)
  {
    names.push(allusers[i].firstname);
    codenames.push(allusers[i].usercode);
    userload.push(<option value={allusers[i].usercode}>{allusers[i].firstname}</option>)
    userobj.push({name:allusers[i].firstname, code:allusers[i].usercode});
  }
  console.log(userobj);
  //console.log(codenames);
  const [selectedusercode, setselusercode]= useState('00');
 //console.log(selectedusercode)

  


 var list = [];
  for (var i = 1; i <= 52; i++) {
    if(i<10)
    {
      i='0'+i;
    }
    list.push(<option value={i.toString()}>{i.toString()}</option>);
  }
    const [selecteduserweek, setseluserweek]= useState('');

    
    

  return (
    <div className="container-fluid">
      <div className="row">
        {/*
        <div className="col-xl-6 col-md-12">
          <div className="cardMUI">
            <div className="cardMUIheader">
              <h4>Inserimento Nuovo Programma:</h4>
            </div>
            <div className="cardMUIbody">
              <UploadFile name={names.toString()} codename={codenames.toString()}/>
            </div>
            <div className="cardMUIfooter">
            </div>
          </div>
        </div>
        */}
        {/*
        <div className="col-xl-6 col-md-12">
          <div className="cardMUI">
            <div className="cardMUIheader">
              <h4>Programmi Inseriti:</h4>
            </div>
            <div className="cardMUIbody">
              <select 
                id='suc'
                key={'a10'} 
                className='dropdownlist col-xl-3 col-md-3' 
                type="text" 
                name='Utente' 
                defaultValue={'00'} 
                onChange={e=>{
                  setselusercode(e.target.value);
                  setseluserweek('00')
                  document.getElementById('suw').value='00';
                  }}>
                <option value={'00'} disabled>Utente</option>
                {userload}
              </select>
              <select 
                id='suw' 
                key={'a3'} 
                className='dropdownlist col-xl-2 col-md-2' 
                type="text" 
                name='setti' 
                defaultValue={'00'} 
                onChange={e=>{
                  setseluserweek(e.target.value);
                  setselusercode('00');
                  document.getElementById('suc').value='00';
                  }}>
                <option value="00" disabled>Settimana</option>
                {list}
              </select>
              <TbAllTrainSess userobj={userobj} selectedusercode={selectedusercode} selecteduserweek={selecteduserweek}/>
            </div>
            <div className="cardMUIfooter">
            </div>
          </div>
        </div>
                */}
        <div className="col-lg-12 col-md-12">
          <div className="cardMUI">
            <div className="cardMUIheader">
              <h4>Inserimento Nuovo Programma:</h4>
            </div>
            <div className="cardMUIbody">
              <Insertweek/>
            </div>
            <div className="cardMUIfooter">
            </div>
          </div>
        </div>
       </div> 
    </div>
  );
};

export default BoardAdmin;

